export default {
  barcode: 'barcode',
  button: 'button',
  cobot: 'cobot',
  decision: 'decision',
  edhr: 'edhr',
  errorProofing: 'errorProofing',
  imageCapture: 'imageCapture',
  lightGuide: 'lightGuide',
  multispindle: 'multispindle',
  nodeRed: 'nodeRed',
  opcUa: 'opcUa',
  pick: 'pick',
  plc: 'plc',
  print: 'print',
  pushToSchedule: 'pushToSchedule',
  serialNumberTransfer: 'serialNumberTransfer',
  timer: 'timer',
  torque: 'torque',
  uploadFile: 'uploadFile',
  viewFile: 'viewFile',
  vision: 'vision',
};
